import makeStyles from "@mui/styles/makeStyles";

export const useStyles = makeStyles(() => ({
  info: {
    display: "flex",
    alignItems: "center",
  },
}));
